<script>
import styled from "vue-styled-components";

const CookieBannerHeadline = styled.div`

    font-size: ${props => props.theme.headlineSize};
    margin: .5rem 0;


`;

export default CookieBannerHeadline;
</script>
